import styled from 'styled-components'
import Image from 'next/legacy/image'
import Link from 'next/link'
import { Typography } from 'common/typography'
import ContentRenderer from 'content-renderer'
import { SecondaryButton } from 'common/button'

const CardStyled = styled.div`
  display: block;
  padding: 16px;
  background: var(--neutral100);
  border-radius: 8px;
  margin-bottom: 32px;
  position: relative;
  .free-tag {
    background: var(--secondary);
    color: var(--white);
    font: var(--smallBold);
    padding: 2px 8px;
    border-radius: 4px;
    position: absolute;
    top: 28px;
    right: 12px;
  }
  &:hover {
    box-shadow: 0 0 3px 1px var(--baseSecondary);
  }
  .title-container {
    max-width: 90%;
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    img {
      border-radius: 50%;
      background: var(--turquoise) 55px 55px center;
    }
    h2 {
      margin-left: 8px;
    }
  }
  p, li {
    font: var(--p2Regular);
    color: var(--white);
  }
  .project-img {
    max-width: 100%;
    vertical-align: bottom;
    margin-bottom: 16px;
  }
  @media(min-width: 768px) {
    margin-bottom: 24px;
    padding: 32px;
    position: relative;
    .title-container {
      max-width: 100%;
    }
    .logo-container {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .free-tag {
      position: static;
      font: var(--p2Bold);
      padding: 2px 8px;
    }
    .title-container {
      display: block;
      h2 {
        margin-left: 0;
        margin-top: 16px;
      }
    }
    p, li {
      font: var(--regular);
    }
    .course-info {
      p, li {
        margin-block-end: 16px;
      }
    }
  }
  @media(min-width: 1024px) {
    .title-container, .course-info {
      max-width: 50%;
    }
    .project-img {
      position: absolute;
      margin-bottom: 0;
      top: 32px;
      right: 32px;
      bottom: 32px;
      max-width: 40%;
      margin: auto 0;
    }
  }
  @media(min-width: 1366px) {
    .title-container, .course-info {
      max-width: 522px;
    }
  }
`

function CourseCard({ course }) {
  const {
    title,
    slug,
    badge: {
      image,
      description: alt,
    },
    featured_video: { thumbnails },
    summary: { blocks: courseSumary },
    project,
    is_free,
    has_access,
  } = course
  const {
    description: projectDescription,
    detail_image: projectImage,
  } = project || {}
  return (
    <Link href={has_access ? `/aprender/${slug}` : `/cursos/${slug}#course`} passHref>
      <CardStyled>
        <div className="title-container">
          <div className="logo-container">
            <Image width="56" height="56" src={image} alt={alt} />
            {is_free ? (
              <span className="free-tag">Gratis</span>
            ) : null}
          </div>
          <Typography as="h2" small="regularBold" large="headline5" color="var(--baseNeutral)">
            {title}
          </Typography>
        </div>
        <div className="course-info">
          <ContentRenderer chunks={projectDescription?.blocks || courseSumary} />
          <img className="project-img" src={projectImage || thumbnails[0]?.link} alt={`Imagen del proyecto del ${title}`} />
          <SecondaryButton fullWidth fitContent>
            {is_free ? 'Ver curso' : 'Ir al curso'}
          </SecondaryButton>
        </div>
      </CardStyled>
    </Link>
  )
}

export default CourseCard
